import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import getDocumentPosition from '../common/get-document-position';
export var SyntaxHighlightingListener = function SyntaxHighlightingListener(state) {
  var _this = this;

  _classCallCheck(this, SyntaxHighlightingListener);

  _defineProperty(this, "state", void 0);

  _defineProperty(this, "highlights", void 0);

  _defineProperty(this, "highlightAstPosition", function (tokenType, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        start = _ref2[0],
        end = _ref2[1];

    var documentFrom = getDocumentPosition(_this.state.doc, start);
    var documentTo = getDocumentPosition(_this.state.doc, end);

    _this.highlights.push({
      tokenType: tokenType,
      documentFrom: documentFrom,
      documentTo: documentTo
    });
  });

  _defineProperty(this, "enterCompoundClause", function (compoundClause) {
    compoundClause.operator.positions.forEach(function (position) {
      _this.highlightAstPosition('keyword', position);
    });
  });

  _defineProperty(this, "enterOrderBy", function (orderBy) {
    _this.highlightAstPosition('keyword', orderBy.operator.position);
  });

  _defineProperty(this, "enterOrderByDirection", function (orderByDirection) {
    _this.highlightAstPosition('keyword', orderByDirection.position);
  });

  _defineProperty(this, "enterField", function (field) {
    _this.highlightAstPosition('field', field.position);
  });

  _defineProperty(this, "enterOperator", function (operator) {
    _this.highlightAstPosition('operator', operator.position);
  });

  _defineProperty(this, "enterPredicateOperator", function (operator) {
    _this.highlightAstPosition('operator', operator.position);
  });

  _defineProperty(this, "enterValueOperand", function (operand) {
    _this.highlightAstPosition('operand', operand.position);
  });

  _defineProperty(this, "enterFunctionOperand", function (operand) {
    _this.highlightAstPosition('operand', operand.position);
  });

  _defineProperty(this, "enterKeywordOperand", function (operand) {
    _this.highlightAstPosition('operand', operand.position);
  });

  this.state = state;
  this.highlights = [];
};